import {Typography} from '@mui/material';
import AurButton from '../../common/aur-button/AurButton';
import {ReactComponent as ExchangeIcon} from '../../../../src/assests/svg/icon_shift.svg';
import {useDispatch, useSelector} from 'react-redux';
import {openDialog} from '../../../redux/slices/reportsDialogSlice';
import ProjectWorkspaceDialog from '../workspace/ProjectWorkspaceDialog';
import ProjectWorkspace from '../workspace/ProjectWorkspace';
import {getUTCDateTimeForDisplay} from '../../../utils/utils';
import {RootState} from '../../../redux/store';
import {useEffect, useState} from 'react';
import {t} from 'i18next';
import AurHighlyConfidential from '../../common/aur-highly-confidential/AurHighlyConfidential';
import {IWorkspace} from '../../../types/workspace-type/workspaceType';
import {AurLightTooltip} from '../../common/aur-light-tooltip/aur-light-tooltip';

const ProcessingSummaryAndExceptionsHeader = () => {
  const dispatch = useDispatch();
  const {
    refreshDates,
    selectedProjectName: projectName,
    selectedWorkSpaceName: workSpaceName,
    workspaceDataSetName: dataSetName,
    worksapceDataSetMediaId: mediaId,
    currentProject: project,
    currentProject,
    workspaceId,
  } = useSelector((state: RootState) => state.reports);

  const [refreshDate, setRefreshDate] = useState<string>('');
  const [selectedWorkSpace, setSelectedWorkSpace] = useState<IWorkspace>();

  const handleOpenDialog = () => {
    dispatch(openDialog());
  };

  useEffect(() => {
    if (refreshDates.processingException && refreshDates.processingSummary) {
      setRefreshDate(
        [
          refreshDates.processingException,
          refreshDates.processingSummary,
        ].reduce(function (a, b) {
          return new Date(a) > new Date(b) ? a : b;
        })
      );
    }
  }, [refreshDates]);

  useEffect(() => {
    if (currentProject?.workspaces) {
      setSelectedWorkSpace(
        currentProject.workspaces?.filter(
          (workspace) => workspace.workspaceId === workspaceId
        )?.[0]
      );
    }
  }, [workspaceId]);

  return (
    <div className="processing-summary-header">
      {project?.highlyConfidential && (
        <AurHighlyConfidential
          type="pill"
          showWarningText={true}
          className="highly-confidential-alert"
        />
      )}
      <div>
        <Typography className="typo-text subhead3_size">
          {projectName}
        </Typography>
      </div>
      <div className="processing-summary-sub-title">
        <Typography className="typo-text subhead3_size">
          {selectedWorkSpace?.workspaceCode} {workSpaceName}
        </Typography>
        <AurButton
          ariaLabel={t(
            'reports.processingExcception.projectWorkspaceDatasetButtonLabel'
          )}
          ariaDescribedBy={t(
            'reports.processingExcception.projectWorkspaceDatasetButtonHint'
          )}
          classNames="typo-text buttonMedium_size"
          onClick={handleOpenDialog}
          type="continue"
          size="Medium"
          startIcon={<ExchangeIcon aria-hidden="true" />}
        >
          {t('common.projectCaption')}
          <span className="color-button-divider"> | </span>
          {t('common.workspace')}{' '}
          <span className="color-button-divider"> | </span>
          {t('common.dataset')}
        </AurButton>
        <ProjectWorkspaceDialog ContentComponent={ProjectWorkspace} />
      </div>
      <div>
        <Typography className="typo-text display3_size">
          {dataSetName} <span className="color-divider"> | </span> {mediaId}
        </Typography>
      </div>
      <div className="processing-summary-date-section">
        <Typography className="typo-text body3_size">
          {t('welcomeScreenSingleClient.dataCurrentAsOf')}{' '}
          <AurLightTooltip title={t('common.yearMonthDate')}>
            <span className="typo-text label1_size processing-summary-date-sub-section">
              {getUTCDateTimeForDisplay(refreshDate)}
            </span>
          </AurLightTooltip>
        </Typography>
        <Typography className="typo-text body3_size">
          {t('processingSummary.rawDataDisclaimer')}
        </Typography>
      </div>
    </div>
  );
};

export default ProcessingSummaryAndExceptionsHeader;
